import { ensureIncreasingXValues } from './utility/ensureIncreasingXValues';
/**
 * Gets the Subfile flags.
 *
 * @param  flag First byte of the subheader.
 * @return The parameters.
 */
export class SubFlagParameters {
    constructor(flag) {
        this.changed = (flag & 1) !== 0;
        this.noPeakTable = (flag & 8) !== 0;
        this.modifiedArithmetic = (flag & 128) !== 0;
    }
}
/**
 * Parses the subheader (header of the subfile)
 *
 * @param buffer SPC buffer.
 * @return subheader object
 */
export class SubHeader {
    constructor(buffer) {
        this.parameters = new SubFlagParameters(buffer.readUint8());
        this.exponentY = buffer.readInt8();
        this.indexNumber = buffer.readUint16();
        this.startingZ = buffer.readFloat32();
        this.endingZ = buffer.readFloat32();
        this.noiseValue = buffer.readFloat32();
        this.numberPoints = buffer.readUint32();
        this.numberCoAddedScans = buffer.readUint32();
        this.wAxisValue = buffer.readFloat32();
        this.reserved = buffer.readChars(4).replace(/\x00/g, '').trim();
    }
}
/**
 * Set the X and Y axis (object with labels, values etc.)
 * @param x
 * @param y
 * @param fileHeader
 * @return object with x and y as axis.
 */
export function setXYAxis(x, y, fileHeader) {
    var _a, _b, _c, _d;
    const xAxis = /(?<label>.*?) ?[([](?<units>.*)[)\]]/.exec(fileHeader.xUnitsType);
    const yAxis = /(?<label>.*?) ?[([](?<units>.*)[)\]]/.exec(fileHeader.yUnitsType);
    const [oX, oY] = ensureIncreasingXValues(x, y);
    const variables = {
        x: {
            symbol: 'x',
            label: ((_a = xAxis === null || xAxis === void 0 ? void 0 : xAxis.groups) === null || _a === void 0 ? void 0 : _a.label) || fileHeader.xUnitsType,
            units: ((_b = xAxis === null || xAxis === void 0 ? void 0 : xAxis.groups) === null || _b === void 0 ? void 0 : _b.units) || '',
            data: oX,
            isDependent: false,
        },
        y: {
            symbol: 'y',
            label: ((_c = yAxis === null || yAxis === void 0 ? void 0 : yAxis.groups) === null || _c === void 0 ? void 0 : _c.label) || fileHeader.yUnitsType,
            units: ((_d = yAxis === null || yAxis === void 0 ? void 0 : yAxis.groups) === null || _d === void 0 ? void 0 : _d.units) || '',
            data: oY,
            isDependent: true,
        },
    };
    return variables;
}
//# sourceMappingURL=shared.js.map